<template>
  <div class="sync-progress px" role="status" aria-live="polite">
    <div class="sync-progress-label">
      <span>{{ displayLabelText }}</span>
      <span v-if="showLoadingDots" class="loading-dots" aria-hidden="true">
        <span>.</span><span>.</span><span>.</span>
      </span>
    </div>
    <a-progress
      class="sync-progress-bar"
      :percent="percent"
      :show-info="false"
      :stroke-color="{
        '0%': '#4136f1',
        '100%': '#8743ff',
      }"
      status="active"
    />
  </div>
</template>

<script>
export default {
  name: "CyberboardR6SyncProgress",
  props: {
    label: { type: String, default: "" },
    percent: { type: Number, default: 0 },
  },
  computed: {
    displayLabel() {
      return this.label.replace(
        /\s*\(?\d+\/\d+\)?(?=\.{0,3}$)/,
        ` ${this.percent}%`
      );
    },
    showLoadingDots() {
      return /\.\.\.$/.test(this.displayLabel);
    },
    displayLabelText() {
      return this.showLoadingDots
        ? this.displayLabel.slice(0, -3)
        : this.displayLabel;
    },
  },
};
</script>

<style lang="scss" scoped>
.sync-progress {
  width: 520px;
  max-width: 80vw;
  margin: 8px auto;
  color: #ffffff;
  font-size: 13px;
  text-align: center;
}

.sync-progress.px {
  font-size: max(10px, 0.13rem);
}

.sync-progress-bar {
  margin: 4px 0 0;
}

.loading-dots {
  display: inline-flex;
  width: 1.2em;
  text-align: left;
}

.loading-dots span {
  opacity: 0;
  animation: sync-progress-dot 1.2s infinite;
}

.loading-dots span:nth-child(2) {
  animation-delay: 0.2s;
}

.loading-dots span:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes sync-progress-dot {
  0%,
  20% {
    opacity: 0;
  }

  40%,
  100% {
    opacity: 1;
  }
}

::v-deep .sync-progress-bar {
  .ant-progress-inner {
    overflow: visible;
    background-color: transparent;
    background-image: linear-gradient(270deg, #8743ff44 0%, #4136f144 100%);
  }

  .ant-progress-bg::after {
    position: absolute;
    top: 50%;
    right: 0;
    width: 12px;
    height: 12px;
    margin-top: -6px;
    border-radius: 50%;
    background: #8743ff;
    content: "";
  }
}
</style>

<style lang="scss">
.ant-modal-wrap.r6-sync-modal .ant-modal .ant-modal-content {
  overflow: hidden;
  border-radius: 8px !important;
  background: #202020 !important;
}

.ant-modal-wrap.r6-sync-modal .ant-modal .ant-modal-header {
  border-radius: 8px 8px 0 0;
  background: #202020 !important;
}

.ant-modal-wrap.r6-sync-modal .ant-modal .ant-modal-body {
  border-radius: 0 0 8px 8px;
  background: #202020;
  padding: 0 24px 20px !important;
}
</style>
